export const COMBO = [
    {
        primary: '#673AB7',
        secondary: '#ec407a',
        white: '#ffff',
        headerScroll: '#512da8',
        sidebarHover: '#d2e5b3',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#2196F3',
        secondary: '#FFC107',
        white: '#ffff',
        headerScroll: '#3F51B5',
        sidebarHover: '#ffebcc',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#4CAF50',
        secondary: '#FF5722',
        white: '#ffff',
        headerScroll: '#009688',
        sidebarHover: '#a5d6a7',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FF9800',
        secondary: '#E91E63',
        white: '#ffff',
        headerScroll: '#795548',
        sidebarHover: '#ffb74d',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#9C27B0',
        secondary: '#FFEB3B',
        white: '#ffff',
        headerScroll: '#607D8B',
        sidebarHover: '#e6ee9c',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FFC107',
        secondary: '#4CAF50',
        white: '#ffff',
        headerScroll: '#E91E63',
        sidebarHover: '#ffd54f',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#E91E63',
        secondary: '#9C27B0',
        white: '#ffff',
        headerScroll: '#FF5722',
        sidebarHover: '#c5e1a5',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#3F51B5',
        secondary: '#673AB7',
        white: '#ffff',
        headerScroll: '#FFC107',
        sidebarHover: '#b2dfdb',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#8BC34A',
        secondary: '#FF9800',
        white: '#ffff',
        headerScroll: '#9C27B0',
        sidebarHover: '#c5cae9',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#00BCD4',
        secondary: '#FF4081',
        white: '#ffff',
        headerScroll: '#FF5722',
        sidebarHover: '#ffe0b2',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FF5722',
        secondary: '#795548',
        white: '#ffff',
        headerScroll: '#4CAF50',
        sidebarHover: '#b2ebf2',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#607D8B',
        secondary: '#4CAF50',
        white: '#ffff',
        headerScroll: '#FF5722',
        sidebarHover: '#ffcc80',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#CDDC39',
        secondary: '#FF5722',
        white: '#ffff',
        headerScroll: '#673AB7',
        sidebarHover: '#d1c4e9',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#4CAF50',
        secondary: '#FFC107',
        white: '#ffff',
        headerScroll: '#03A9F4',
        sidebarHover: '#ffccbc',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FF5722',
        secondary: '#3F51B5',
        white: '#ffff',
        headerScroll: '#8BC34A',
        sidebarHover: '#ffe0b2',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FF4081',
        secondary: '#00BCD4',
        white: '#ffff',
        headerScroll: '#4CAF50',
        sidebarHover: '#ffe0b2',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#2196F3',
        secondary: '#FFC107',
        white: '#ffff',
        headerScroll: '#3F51B5',
        sidebarHover: '#ffebcc',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FFC107',
        secondary: '#4CAF50',
        white: '#ffff',
        headerScroll: '#E91E63',
        sidebarHover: '#ffd54f',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#E91E63',
        secondary: '#9C27B0',
        white: '#ffff',
        headerScroll: '#FF5722',
        sidebarHover: '#c5e1a5',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#3F51B5',
        secondary: '#673AB7',
        white: '#ffff',
        headerScroll: '#FFC107',
        sidebarHover: '#b2dfdb',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#8BC34A',
        secondary: '#FF9800',
        white: '#ffff',
        headerScroll: '#9C27B0',
        sidebarHover: '#c5cae9',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#00BCD4',
        secondary: '#FF4081',
        white: '#ffff',
        headerScroll: '#FF5722',
        sidebarHover: '#ffe0b2',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#FF5722',
        secondary: '#795548',
        white: '#ffff',
        headerScroll: '#4CAF50',
        sidebarHover: '#b2ebf2',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#607D8B',
        secondary: '#4CAF50',
        white: '#ffff',
        headerScroll: '#FF5722',
        sidebarHover: '#ffcc80',
        black: '#000',
        gray: 'gray',
    },
    {
        primary: '#CDDC39',
        secondary: '#FF5722',
        white: '#ffff',
        headerScroll: '#673AB7',
        sidebarHover: '#d1c4e9',
        black: '#000',
        gray: 'gray',
    },
    {

        primary: '#000000',        // White
        secondary: 'rgba(128, 128, 128, 0.8)',      // Black
        accent: '#CDDC39',         // Yellow (as an accent color)
        headerScroll: '#666666',   // Dark Gray (for header scroll)
        sidebarHover: '#CCCCCC',
        black: '#000',
        gray: 'rgba(96, 125, 139, 0.8)',
        white: '#ffff',
    },
];



//24 index max
export const COLORS = COMBO[25]; 
